import type { ReportCatalogEntry, ReportConfiguration } from '../types/reportTypes';

// Placeholder query function — will be replaced with real implementations in the query layer task.
const placeholderQueryFn = async (_companyId: string, _config: ReportConfiguration): Promise<any[]> => [];

/** Standard report type catalog — 16 entries across 4 categories */
export const REPORT_CATALOG: ReportCatalogEntry[] = [
    // ─── Tire Maintenance ───
    {
        key: 'tire-wear-by-asset',
        displayName: 'Tire Wear by Asset',
        category: 'tire-maintenance',
        defaultMetric: 'tire-wear-pct',
        defaultGroupBy: 'asset',
        defaultVisualization: 'bar',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'tire-cost-per-um',
        displayName: 'Tire Cost per UM',
        category: 'tire-maintenance',
        defaultMetric: 'tire-cost-per-um',
        defaultGroupBy: 'asset',
        defaultVisualization: 'table',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'tire-replacement-history',
        displayName: 'Tire Replacement History',
        category: 'tire-maintenance',
        defaultMetric: 'tire-replacement-frequency',
        defaultGroupBy: 'date',
        defaultVisualization: 'line',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'failure-reason-report',
        displayName: 'Failure Reason Report',
        category: 'tire-maintenance',
        defaultMetric: 'tire-failure-count',
        defaultGroupBy: 'category',
        defaultVisualization: 'pie',
        queryFn: placeholderQueryFn,
    },

    // ─── PM Reports ───
    {
        key: 'pm-compliance',
        displayName: 'PM Compliance Report',
        category: 'pm-reports',
        defaultMetric: 'pm-compliance-pct',
        defaultGroupBy: 'category',
        defaultVisualization: 'bar',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'pm-cost-by-service-level',
        displayName: 'PM Cost by Service Level',
        category: 'pm-reports',
        defaultMetric: 'pm-cost-by-service-level',
        defaultGroupBy: 'category',
        defaultVisualization: 'bar',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'upcoming-pm-schedule',
        displayName: 'Upcoming PM Schedule',
        category: 'pm-reports',
        defaultMetric: 'upcoming-pm-count',
        defaultGroupBy: 'asset',
        defaultVisualization: 'table',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'utilization-report',
        displayName: 'Utilization % Report',
        category: 'pm-reports',
        defaultMetric: 'utilization-pct',
        defaultGroupBy: 'asset',
        defaultVisualization: 'bar',
        queryFn: placeholderQueryFn,
    },

    // ─── Cost Tracking ───
    {
        key: 'total-cost-by-asset',
        displayName: 'Total Cost by Asset',
        category: 'cost-tracking',
        defaultMetric: 'total-cost',
        defaultGroupBy: 'asset',
        defaultVisualization: 'table',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'cost-by-category',
        displayName: 'Cost by Category',
        category: 'cost-tracking',
        defaultMetric: 'expense-by-category',
        defaultGroupBy: 'category',
        defaultVisualization: 'pie',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'cost-trend',
        displayName: 'Cost Trend',
        category: 'cost-tracking',
        defaultMetric: 'total-cost',
        defaultGroupBy: 'date',
        defaultVisualization: 'line',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'vendor-spend',
        displayName: 'Vendor Spend Report',
        category: 'cost-tracking',
        defaultMetric: 'vendor-spend',
        defaultGroupBy: 'vendor',
        defaultVisualization: 'bar',
        queryFn: placeholderQueryFn,
    },

    // ─── Safety ───
    {
        key: 'inspection-compliance',
        displayName: 'Inspection Compliance',
        category: 'safety',
        defaultMetric: 'incident-count',
        defaultGroupBy: 'date',
        defaultVisualization: 'line',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'inop-trend',
        displayName: 'Out of Service Trend',
        category: 'safety',
        defaultMetric: 'incident-count',
        defaultGroupBy: 'date',
        defaultVisualization: 'line',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'warn-inop-by-asset',
        displayName: 'Warn/Inop by Asset',
        category: 'safety',
        defaultMetric: 'incident-count',
        defaultGroupBy: 'asset',
        defaultVisualization: 'bar',
        queryFn: placeholderQueryFn,
    },
    {
        key: 'safety-training-completion',
        displayName: 'Safety Training Completion',
        category: 'safety',
        defaultMetric: 'training-compliance-pct',
        defaultGroupBy: 'category',
        defaultVisualization: 'table',
        queryFn: placeholderQueryFn,
    },
];
